import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const aromaColorPickerDefaultVariants = {}
const aromaColorPickerCompoundVariants = []

const aromaColorPickerSlotNames = [
  [
    "root",
    "aroma-color-picker__root"
  ],
  [
    "input",
    "aroma-color-picker__input"
  ],
  [
    "trigger",
    "aroma-color-picker__trigger"
  ],
  [
    "control",
    "aroma-color-picker__control"
  ],
  [
    "swatch",
    "aroma-color-picker__swatch"
  ],
  [
    "content",
    "aroma-color-picker__content"
  ],
  [
    "select",
    "aroma-color-picker__select"
  ],
  [
    "area",
    "aroma-color-picker__area"
  ],
  [
    "areaBackground",
    "aroma-color-picker__areaBackground"
  ],
  [
    "areaThumb",
    "aroma-color-picker__areaThumb"
  ],
  [
    "channelSlider",
    "aroma-color-picker__channelSlider"
  ],
  [
    "channelSliderThumb",
    "aroma-color-picker__channelSliderThumb"
  ],
  [
    "channelSliderTrack",
    "aroma-color-picker__channelSliderTrack"
  ],
  [
    "swatchGroup",
    "aroma-color-picker__swatchGroup"
  ],
  [
    "swatchTrigger",
    "aroma-color-picker__swatchTrigger"
  ],
  [
    "colorView",
    "aroma-color-picker__colorView"
  ],
  [
    "channelInput",
    "aroma-color-picker__channelInput"
  ]
]
const aromaColorPickerSlotFns = /* @__PURE__ */ aromaColorPickerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, aromaColorPickerDefaultVariants, getSlotCompoundVariant(aromaColorPickerCompoundVariants, slotName))])

const aromaColorPickerFn = memo((props = {}) => {
  return Object.fromEntries(aromaColorPickerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const aromaColorPickerVariantKeys = []
const getVariantProps = (variants) => ({ ...aromaColorPickerDefaultVariants, ...compact(variants) })

export const aromaColorPicker = /* @__PURE__ */ Object.assign(aromaColorPickerFn, {
  __recipe__: false,
  __name__: 'aromaColorPicker',
  raw: (props) => props,
  variantKeys: aromaColorPickerVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, aromaColorPickerVariantKeys)
  },
  getVariantProps
})